//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Organization",
  data() {
    return {
      oneGroupList: [],
      twoGroupList: [],
      activeId: "",
      twoGroupLoad: false,
      masterId: "",
    };
  },
  components: {},
  filters: {},
  watch: {},
  created() {
    let { $businessAccountId } = this.$route.query;
    this.masterId = $businessAccountId;
    this.getOneLevelGroup({ masterId: $businessAccountId }, (id) => {
      this.activeId = id;
      this.getTwoLevelGroup(id);
    });
  },
  mounted() {},
  methods: {
    /**
     * @description: 获取一级组织目录
     * @Author: yangsibo
     * @Date: 2022-06-07 10:36:09
     * @param {*} masterId 村集体id
     */
    async getOneLevelGroup(masterId, callback) {
      try {
        let { data } = await this.$http.village.oneLevelVillGroup(masterId);
        this.oneGroupList = data;
        callback && callback(data[0].id);
      } catch (error) {}
    },
    /**
     * @description: 获取二级组织目录
     * @Author: yangsibo
     * @Date: 2022-06-07 11:10:19
     * @param {*} id
     * @return {*}
     */
    async getTwoLevelGroup(id) {
      this.twoGroupLoad = true;
      try {
        let { data } = await this.$http.village.twoLevelVillGroup({
          id,
          masterId: this.masterId,
        });
        this.twoGroupList = data;
        this.twoGroupLoad = false;
      } catch (error) {
        this.twoGroupLoad = false;
      }
    },
    /**
     * @description: 选中一级组织
     * @Author: yangsibo
     * @Date: 2022-06-07 11:20:33
     * @param {*} group 选中的一级组织
     */
    selectGroup(group) {
      this.activeId = group.id;
      this.getTwoLevelGroup(group.id);
    },
  },
};
